import React from 'react';
import { Page, Document } from 'react-pdf'
import PDFjsSettings from "../PDFjsSettings";
import { isMobile } from 'react-device-detect';
import classnames from "classnames";
import shortid from "shortid";

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import './Viewer.scss';
import { Loader } from '../Loader/Loader';

export interface IViewerProps {
    file: string,
    scale: number,
}

export class Viewer extends React.Component<IViewerProps, any> {
    constructor(props: IViewerProps) {
        super(props);

        this.state = {
            file: '',
            numPages: null,
            windowWidth: window.innerWidth
        }


    }

    onFileChange = (event: any) => {
        this.setState({
            file: event.target.files[0],
        });
    }

    onDocumentLoadSuccess = (data: any) => {
        this.setState({ numPages: data.numPages });
    }

    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    componentDidMount() {
        if (isMobile) {
            window.addEventListener("resize", this.handleResize);
        }
    }

    componentWillMount() {
        window.addEventListener("resize", this.handleResize);
    }

    get windowWidth() {
        if (this.state.windowWidth > 1120) {
            return 1120;
        }
        return this.state.windowWidth;
    }

    render() {
        const { file, numPages } = this.state;

        return (
            <div className={classnames("Viewer", { "mobile": isMobile, "desktop": !isMobile })}>
                <Document file={this.props.file} onLoadSuccess={this.onDocumentLoadSuccess} options={PDFjsSettings.options} loading={<Loader />} >
                    {
                        Array.from(
                            new Array(numPages),
                            (el, index) => (
                                <div key={`page_` + shortid.generate()} style={{ marginBottom: "5px" }}>
                                    <Page loading={""} pageNumber={index + 1} width={this.windowWidth} scale={this.props.scale} />
                                </div>
                            ),
                        )
                    }
                </Document>
            </div>
        );
    }
}

export default Viewer;